<template>
    <nav class="navbar">
        <div class="container">
            <a href="/"><img src="../assets/pod.png" alt="Pillars of Dust"></a>
        </div>
    </nav>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.navbar {
    background-color: #000000;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    opacity: .7;
}
</style>